
export const PIECEWORK_WAGE_TABLE = {
  day: {
    name: '日工资',
    id: 'day'
  },
  month: {
    name: '月度工资',
    id: 'month'
  }
}

export const DAY_COLS = [
  {
    title: "加工组织",
    dataIndex: "organizationName",
    width: 160
  },
  {
    title: "工作中心",
    dataIndex: "centerName",
    width: 150
  },
  {
    title: "班组",
    dataIndex: "teamName",
    width: 150
  },
  {
    title: "人员",
    dataIndex: "employeeName",
    width: 150
  },
  {
    title: "生产日期",
    dataIndex: "produceTime",
    width: 150
  },
  {
    title: "CC工单号",
    dataIndex: "upstreamWorkNumber",
    width: 130
  },
  {
    title: "MO票号",
    dataIndex: "moTicketCode",
    width: 130
  },
  {
    title: "成品SKU",
    dataIndex: "assemblyItemCode",
    width: 150
  },
  {
    title: "成品名称",
    dataIndex: "assemblyItemName",
    scopedSlots: { customRender: "textEllipsis" },
    width: 150
  },
  {
    title: "规格",
    dataIndex: "specification",
    width: 140,
    ellipsis: true
  },
  {
    title: "物料编码",
    dataIndex: "requireItemStr",
    width: 100
  },
  {
    title: "排产数量",
    dataIndex: "planQuantity",
    width: 100
  },
  {
    title: "完工数量",
    dataIndex: "transactionQty",
    width: 100
  },
  {
    title: "材料BOM用量*排产数",
    dataIndex: "zpStandarQuantity",
    width: 100
  },
  {
    title: "领料数量",
    dataIndex: "zpRequisitionQuantity",
    width: 100
  },
  {
    title: "补料数量",
    dataIndex: "zpReplenishQuantity",
    width: 100
  },
  {
    title: "退料数量",
    dataIndex: "zpBackQuantity",
    width: 100
  },
  {
    title: "超/省尺数",
    dataIndex: "zpOverQuantity",
    width: 100
  },
  {
    title: "计件工价",
    dataIndex: "calWages",
    width: 100
  },
  {
    title: "计件工资",
    dataIndex: "calSalary",
    width: 100
  },
  {
    title: "真皮超/省尺单价",
    dataIndex: "zpPoLaborWages",
    width: 100
  },
  {
    title: "激励金额",
    dataIndex: "zpPoLaborSalary",
    width: 100
  },
  {
    title: "当日合计工资/元",
    dataIndex: "dailyTotalSalary",
    width: 100
  },
  {
    title: "确认日工资",
    dataIndex: "confirmSalary",
    scopedSlots: { customRender: "confirmSalary" },
    width: 100
  },
  {
    title: "备注",
    dataIndex: "remark",
    scopedSlots: { customRender: "remark" },
    width: 100
  },
  {
    title: "数据生成时间",
    dataIndex: "createTime",
    width: 100
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    stickyFixed: 'right',
    align: 'center',
    width: 100
  }
]

export const MONTH_COLS = [
  {
    title: "加工组织",
    dataIndex: "organizationName",
    width: 150
  },
  {
    title: "人员",
    dataIndex: "employeeName",
    width: 150
  },
  {
    title: "年月",
    dataIndex: "produceTime",
    scopedSlots: { customRender: "monthFormat" },
    width: 100
  },
  {
    title: "计件月总额",
    dataIndex: "monthTotalSalary",
    width: 100
  },
  {
    title: "激励月总额",
    dataIndex: "monthZpPoLaborSalary",
    width: 100
  },
  {
    title: "月合计工资/天",
    dataIndex: "monthConfirmSalary",
    width: 100
  },
  {
    title: "数据生成时间",
    dataIndex: "createTime",
    width: 100
  },
  {
    title: '操作',
    dataIndex: 'operationMonth',
    scopedSlots: { customRender: 'operationMonth' },
    stickyFixed: 'right',
    align: 'center',
    width: 100
  }
]

export const DAY_SEARCH_LIST = [
  {
    label: "组织",
    type: "organizationCode"
  },
  {
    label: '工作中心',
    type: "centerCode",
    decorator: ["centerCode"],
    attrs: {
      placeholder: "请输入"
    }
  },
  {
    label: "班组",
    type: "teamGroupCode",
    decorator: ["teamGroupCode"],
    attrs: {
      placeholder: "请输入"
    }
  },
  {
    label: "人员",
    type: "employeeCode",
    decorator: ["employeeCode"],
    attrs: {
      placeholder: "请输入"
    }
  },
  {
    label: "生产日期",
    type: "produceTimeDay",
    attrs: {}
  },
  {
    label: "CC工单号",
    type: "input",
    decorator: ["upstreamWorkNumber"],
    attrs: {
      placeholder: "请输入"
    }
  },
  {
    label: "MO票号",
    type: "input",
    decorator: ["moTicketCode"],
    attrs: {
      placeholder: "请输入"
    }
  },
  {
    label: "成品SKU",
    type: "input",
    decorator: ["assemblyItemCode"],
    attrs: {
      placeholder: "请输入"
    }
  },
  {
    label: "物料编码",
    type: "input",
    decorator: ["requireItemCode"],
    attrs: {
      placeholder: "请输入"
    }
  }
]

export const MONTH_SEARCH_LIST = [
  {
    label: "组织",
    type: "organizationCode"
  },
  {
    label: '人员',
    type: "employeeCode",
    decorator: ["employeeCode"],
    attrs: {
      placeholder: "请输入"
    }
  },
  {
    label: "年月",
    type: "produceTimeMonth",
    attrs: {
      placeholder: "请输入"
    }
  }
]

// 状态
export const STATUS_CODE = {
  enabled: { label: '是', value: 1 },
  disabled: { label: '否', value: 0 }
}

export function positiveNumValidate(rule, value, callbackFunc) {
  console.log(value)
  if(value === undefined || value === '' || value === null) {
    callbackFunc();
  } else if(value <= 0) {
    callbackFunc('不可小于等于0')
  }else {
    callbackFunc()
  }
}
